import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { sourceTypes, sourceActions } = createActionsStructure('source', [
  { name: 'GET_SOURCES', async: true },
  { name: 'SUBSCRIBE_MONTH_SOURCES_DATA', async: true },
  { name: 'UNSUBSCRIBE_MONTH_SOURCES_DATA', async: true },
  { name: 'UPDATE_MONTH_SOURCES_DATA', async: true },
  { name: 'SET_MONTH_SOURCES_DATA', async: true },
  { name: 'ADD_SOURCE_BOOKING', async: true },
  { name: 'RESET_SOURCE', async: true },
  { name: 'CLEAR_SOURCES', async: false }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/SourceActions.js